function videoCheck() {
	var slide = globalVar.slide;

	if (slide.data.type == 'video') {
		var video = slide.$.find('video')[0];
		var videoID = slide.$.find('video')[0].id;

		if (slide.data.videoLoaded == false) videoInit(slide, videoID);
		else videoRestart(videoID);
	} else {
		if ($('section').find('video').length > 0) {
			$('section').find('video')[0].pause();
		}
	}

	if (slide.data.transcript) $('#si-transcript').attr('href', slide.data.transcript);
}

function videoInit(slide, videoID) {
	videojs(videoID, {
		language: 'en',
		autoplay: true,
		controlBar: {
			volumePanel: {
				inline: true
			}
		},
		html5: {
			// https://docs.videojs.com/docs/guides/text-tracks.html#emulated-text-tracks
			// prevents iPhone and safari from using their own subtitle system
			nativeTextTracks: false
		},
		plugins: {
			// https://github.com/kmoskwiak/videojs-resolution-switcher#plugin-options
			videoJsResolutionSwitcher: {
				default: 'high',
				dynamicLabel: true
			},
			// https://github.com/ctd1500/videojs-hotkeys#options
			hotkeys: {
				enableNumbers: false,
				enableModifiersForNumbers: false,
				alwaysCaptureHotkeys: true
			},
			seekButtons: {
				back: 10
			}
		}
	}).ready(function () {
		// disable progress control (seeking) if globalVar or data.js is configured that way.
		// videoSeeking (data.js) is overruling progressControl (globalVar).
		// if devMode is on, seeking is always enabled.

		if (!globalVar.devMode) {
			if (!slide.data.videoSeeking) {
				if (slide.data.videoSeeking === false || globalVar.video.progressControl === false) {
					videojs(videoID).controlBar.progressControl.disable();
				}
			}
		}

		if (videojs(videoID).textTracks().tracks_.length > 0) {
			// subtitle/captions style is set up here (defaults in comments)
			// NOTE: use #XXX hex style for colors! #xxx or #xxxxxx will not work!
			var subtitleSettings = {
				backgroundOpacity: '0.5', //				"1"
				edgeStyle: 'dropshadow', //					not set (none, null, 0, '' doesn't work, only not setting it at all will set it to 'none')
				color: '#FFF', //							"#FFF"
				backgroundColor: '#000', //					"#000"
				textOpacity: '1', //						"1"
				windowOpacity: '0', //						"0"
				fontFamily: 'proportionalSansSerif', //		"proportionalSansSerif"
				windowColor: '#FFF' //						"#000"
				//fontPercent: 1 //							not set (1, 1.0, 1.00, etc doesn't work, only not setting it at all will set it to 100%)
			};
			videojs(videoID).textTrackSettings.setValues(subtitleSettings);
			videojs(videoID).textTrackSettings.updateDisplay();

			// this would show the first subtitle track
			// videojs(videoID).textTracks_[0].mode = "showing"

			// prints out a nice table of the current subtitle style settings
			// console.table(videojs(videoID).textTrackSettings.getValues());
		}

		slide.data.videoLoaded = true;

		videojs(videoID).play();

		// Old way of disabling seeking.
		// Obsolete because it's not reliable in IE. New native method is.
		/* if (slide.data.videoSeeking == false) {
		var supposedCurrentTime = 0;
		video.addEventListener('timeupdate', function() {
			if (!video.seeking) {
				supposedCurrentTime = video.currentTime;
			}
		});
		//allows backwards movement of trackbar but can't move trackbar forward
		video.addEventListener('seeking', function() {
			if (video.currentTime > supposedCurrentTime) {
				video.currentTime = supposedCurrentTime;
			}
		});
	} */
	});
	videojs(videoID).on('ended', function () {
		globalVar.videoSeen[slide.id] = true;
		if (slide.data.coinSettings.include === true) {
			addCoins();
		}
		slideAction(slide.id, 'nextAction');
	});
	if (globalVar.fadeNavigation) {
		videojs(videoID).on('useractive', function () {
			$('#si-nav-container').removeClass('vjs-fade-out');
		});

		videojs(videoID).on('userinactive', function () {
			if (!videojs(videoID).paused()) {
				$('#si-nav-container').addClass('vjs-fade-out');
			}
		});
	}
}

function videoRestart(videoID) {
	videojs(videoID).currentTime(0);
	videojs(videoID).play();
}
